import { createRouter as e, createWebHistory as o } from "vue-router";
import t from "../views/HomeView.vue";
import i from "../utils/checkLogin";
import n from "@/utils/checkUser";
let router = e({
  history: o(import.meta.env.BASE_URL),
  routes: [
    { path: "/", name: "home", component: t },
    {
      path: "/plan/:plan_name",
      name: "plan",
      component: () => import("../views/PlanView.vue"),
    },
    {
      path: "/page/:page_name/:page_id",
      name: "page",
      component: () => import("../views/EachPageView.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("../views/AboutUsView.vue"),
    },
    {
      path: "/blogs",
      name: "blogs",
      component: () => import("../views/blogsView.vue"),
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: () => import("../views/ContactUsView.vue"),
    },
    {
      path: "/Subscribe",
      name: "Subscribe",
      component: () => import("../views/SubscribeView.vue"),
    },
    {
      path: "/our-network",
      name: "OurNetwork",
      component: () => import("../views/OurNetwork.vue"),
    },
    {
      path: "/provider/:packageName",
      name: "listing",
      component: () => import("../views/EachCard.vue"),
    },
    {
      path: "/blog/:blogName",
      name: "blog",
      component: () => import("../views/EachBlogView.vue"),
    },
    {
      path: "/my-account",
      name: "my-account",
      component: () => import("../views/MyAccount.vue"),
      beforeEnter: n,
    },
    {
      path: "/Login",
      name: "Login",
      component: () => import("../views/LoginView.vue"),
      beforeEnter: i,
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("../views/RegisterView.vue"),
      beforeEnter: i,
    },
    {
      path: "/forget-password",
      name: "forgetPassword",
      component: () => import("../views/ForgetPasswordView.vue"),
      beforeEnter: i,
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: () => import("../views/ResetPasswordView.vue"),
      beforeEnter: i,
    },
    {
      path: "/verify-email",
      name: "VerifyEmail",
      component: () => import("../views/VerifyEmailView.vue"),
      beforeEnter: i,
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () => import("../views/PrivacyPolicyView.vue"),
    },
    {
      path: "/terms-and-condition",
      name: "terms-and-condition",
      component: () => import("../views/TermsAndConditionsView.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("../views/NotFoundView.vue"),
    },
  ],
});
router.beforeEach((e, o, t) => {
  window.scrollTo(0, 0), t();
});
export default router;
